import React from "react";

const ErrorPage = () => {
  return (
    <div className="h-screen w-screen flex items-center justify-center">
      <h1 className="text-4xl font-bold">404</h1>
    </div>
  );
};

export default ErrorPage;
